import { render, staticRenderFns } from "./warningIndex.vue?vue&type=template&id=56c5ab02"
import script from "./warningIndex.vue?vue&type=script&lang=js"
export * from "./warningIndex.vue?vue&type=script&lang=js"
import style0 from "./warningIndex.vue?vue&type=style&index=0&id=56c5ab02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports